module.exports = __webpack_public_path__ + "static/media/chittagong-medical-college-hospital-cmch-logo-0387EE353D-seeklogo.com.fa3b08c3.png";